module.exports = __webpack_public_path__ + "static/media/7.792f1e91.jpg";